import React from "react";
import {
  Modal,
} from "reactstrap";
import {
  UpperTitle,
} from "components/StyledComponents";
import ShipmentReportResult from "./ShipmentReportResult";

export const ShipmentModal = ({
  code,
  isOpen,
  close,
}) => (
  <React.Fragment>
    <Modal
      isOpen={isOpen}
      zIndex={9999}
      style={{
        width: "80%",
        maxWidth: "1000px",
      }}
    >
      <div className="modal-header justify-content-center" style={{ display: "block", border: "none" }}>
        <div style={{
          display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "center",
        }}
        >
          <UpperTitle>Relatório</UpperTitle>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => close()}
          >
            <i className="nc-icon nc-simple-remove" />
          </button>
        </div>
      </div>
      <div style={{ width: "100%", backgroundColor: "#f6f8ff" }}>
        <div style={{ width: "98%", margin: "0 auto" }}>
          {code && (
            <React.Fragment>
              <ShipmentReportResult code={code} />
            </React.Fragment>
          )}
        </div>
      </div>
    </Modal>
  </React.Fragment>
);
